import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { PRIVACY_POLICY_PATH } from '@/components/privacyPolicy/types';

const PrivacyPolicyPage = lazy(() =>
  import('@/components/privacyPolicy/PrivacyPolicyPage').then(({ PrivacyPolicyPage }) => ({
    default: PrivacyPolicyPage,
  })),
);

export const PrivacyPolicyRoute: AppRouteConfig = {
  key: 'privacy-policy-page',
  path: `${PRIVACY_POLICY_PATH}/:locale?`,
  component: PrivacyPolicyPage,
};
